import { render, staticRenderFns } from "./SetCenter.vue?vue&type=template&id=bcab5424"
import script from "./SetCenter.vue?vue&type=script&lang=js"
export * from "./SetCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports